module.exports = __webpack_public_path__ + "img/mma.06fb5912.svg";